// extracted by mini-css-extract-plugin
export var cartIcon = "_ob-0";
export var cartIconContainer = "_ob-1";